import React, { useState } from "react";
import { Box } from '@mui/material';
import Header from "../Header";
import SideBar from "../SideBar";
import SideForm from "../SideForm";
import useMediaQuery from "../../../base/useMediaQuery";
import clsx from "clsx";

/**
 * @author Sarthak Sharma.
 * @since 27-12-2023.
 * @description Layout component.
 */

const MainLayout = ({ children, open, onClose, FormComponent }): React.ReactElement => {
    const isDeskTop = useMediaQuery('(min-width: 850px)');
    const [navBarOpen, setNavBar] = useState(isDeskTop);

    return (
        <Box className=" bg-[#F6F6F7] h-screen fixed top-0 left-0 w-full">
            <Header open={navBarOpen} setNavBar={setNavBar} />
            <div style={{ paddingTop: isDeskTop ? '90px' : '90px' }} className={clsx("relative flex h-screen")}>
                <SideBar open={navBarOpen} setNavBar={setNavBar} />
                <section className="w-full overflow-auto pb-28"> {children} </section>
                <SideForm open={open} onClose={onClose}> {FormComponent} </SideForm>
            </div>
        </Box>
    );
}

export default React.memo(MainLayout, (prevProps, nextProps) => {
    return (
        prevProps.children === nextProps.children &&
        prevProps.open === nextProps.open &&
        prevProps.FormComponent === nextProps.FormComponent
    );
});